module.exports = __webpack_public_path__ + "static/media/028-woman-7.dcd5c1a0.svg";